import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

// 保存用户
export const saveUser = data => {
    return api.post(`${baseApi}/user/addUser`, data);
};

// 编辑用户
export const editUser = data => {
    return api.post(`${baseApi}/user/updateUser`, data);
};

// 查询用户
export const getUser = data => {
    return api.post(`${baseApi}/user/getUserListPage`, data);
};

// 获取当前登录用户详情
export const getUserInfo = params => {
    return api.get(`${baseApi}/user/getCurrentUserInfo`, { params });
};

// 获取当前用户详情
export const getUserInfoDetail = ({ userId }) => {
    return api.get(`${baseApi}/user/getUserInfo/${userId}`);
};

// 删除用户
export const deleteUser = userId => {
    return api.post(`${baseApi}/user/removeUser/${userId}`);
};

// 重置密码
export const resetPassword = params => {
    return api.post(`${baseApi}/user/resetPassword`, { params });
};

// 修改密码
export const updatePassword = data => {
    return api.post(`${baseApi}/user/updatePassword`, data);
};

// 修改自身密码
export const updateSelfPassword = data => {
    return api.post(`${baseApi}/user/updatePasswordMyself`, data);
};

// 启用停用
export const changeStatus = ({ userId, status }) => {
    return api.post(`${baseApi}/user/updateStatus/${userId}/${status}`);
};

// 获取用户分组
export const getUserGroup = data => {
    return api.post(`${baseApi}/user/getUserListByExpGroupCode`, data);
};

export const updateUserExpression = data => {
    return api.post(`${baseApi}/user/updateUserExpression`, data);
};

export const getUserTree = () => {
    return api.get(`${baseApi}/user/getUserTree`);
};

export const getUserListAll = data => {
    return api.post(`${baseApi}/user/userList`, data);
};

export const updateUserBatch = data => {
    return api.post(`${baseApi}/user/updateUserParentBatch`, data);
};
